/* eslint import/prefer-default-export:0 */

export function sortTimeseriesByTitle(ts) {
  return ts.sort((a, b) => {
    const aTitle = a.title || a.name
    const bTitle = b.title || b.name
    return aTitle.localeCompare(bTitle)
  })
}
